/**
 * 값이 enum에 속하면 해당 값을 반환, 아니면 undefined
 * @param value - 검증할 값
 * @param enumObj - enum 객체
 * @returns 유효한 enum 값 또는 undefined
 */
export const toEnumValue = <T extends string>(
    value: string | null | undefined,
    enumObj: Record<string, T>,
): T | undefined => {
    if (value == null) { 
        return undefined; 
    }
    return Object.values(enumObj).find(v => v === value);
};